import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MultipleSelectItemComponent } from '../../inventory/multiple-select-item/multiple-select-item.component';
import { DataService } from "../../services/data.service";
import { APIService } from '../../api.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { formatDate, DatePipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { ItemEntryComponent } from 'src/app/inventory/item-entry/item-entry.component';
import { FindCompComponent } from '../../find-comp/find-comp.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-create-production-job',
  templateUrl: './create-production-job.component.html',
  styleUrls: ['./create-production-job.component.scss']
})
export class CreateProductionJobComponent implements OnInit {


  @Input() mdlRef: any;
  @Input() Data:any;
  @Input() prTypeID: number = 1;
  // @Input() isFromProjectMod: boolean = false;
  items: any = [];
  itemsData: any = [];
  OrederItems:any = [];
  customerList: CstrList[] = [];
  cstrCtrl = new FormControl();
  filteredCstr!: Observable<CstrList[]>;
  generationList: any = [];
  ErpConfig:any = [];
  data: any = {
    tempcstrName: '',
    jobID: 0,
    cstrID: 0,
    CurrStageID: 0,
    CurrStageName: '',
    cstrName: '',
    WipNo: '',
    instruction: '',
    Stages: [],
    CstrRelativeID: 0,
    CstrRelName: '',
    OrderID: 0,
    targetDate:new Date(),
    OrderNo:'',
    projectWipNo: '',
    users: [],
    launchDT: new Date()
  }
  pipe = new DatePipe('en-IN');
  lastMonth: any = new Date(new Date().getFullYear(), new Date().getMonth() + 0, 1);
  startDate: any = new FormControl(new Date(this.lastMonth));
  todayDate: Date = new Date();
  lastWIPNo: any;
  isShowPrevNo: boolean = false;
  ErpProd: any = [];
  lastProjectWIPNo: any;
  userList: Array<any> = [];
  selectedUserID: number = 0;
  innerWidth: any;
  isMobileView: boolean = false;

  constructor(private activeModal: NgbActiveModal, private modalService: NgbModal, private appService: DataService, private apiService: APIService, private dateAdapter: DateAdapter<Date>, private commonService: CommonService) {
    this.dateAdapter.setLocale('en-IN');
  
  }
  productList: any = [];
  modalReference: any;
  agencyData: any = [];
  jarvisData: any = [];
  firstTime: boolean = true;
  projectType: string = '';
  newStage: string = '';
  selectedFile: File | null = null;
  fileName: string = '';
  fileBase64: string = '';
  allowPrdFile: any = [];

  copyDescFromOrder: boolean = false;

  get isCopyDescVisible(): boolean {
    // Only show if job is from an order (data.OrderID is set), items exist, 
    // and every item came from the order (has OrderItemID).
    return this.data.OrderID !== 0 && 
           this.items.length > 0 && 
           this.items.every((x: any) => x.OrderItemID);
  }

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let users = this.apiService.getCookie('J');
    if (users) {
      var userID = this.jarvisData[0].UserID;
      this.userList = users ? JSON.parse(users): [];
      this.userList = this.userList.sort((a: any, b: any) => a.Name.localeCompare(b.Name));
      this.userList.forEach((user: any) => {
        user.selected = false;
      })
    }
    // if(this.prTypeID == 2){
    //   this.isFromProjectMod = true;
    // }
     //Get H from IDB
     var self = this;
     let hCookie = this.apiService.getIDB('H', function(dataList: any){
       if(dataList){ 
         self.customerList = dataList;
         self.customerList = self.customerList.sort((a: any, b: any) => a.Cmp.localeCompare(b.Cmp))
       }
       self.filteredCstr = self.cstrCtrl.valueChanges
       .pipe(
         startWith(''),
         map(x => x ? self._filterCstr(x) : self.customerList.slice())
       );
     })


    let tempErpConfig = this.apiService.getCookie("ERP_Cfg")
    if (tempErpConfig) {
      this.ErpConfig = JSON.parse(tempErpConfig);
      if(this.prTypeID == 1){
        this.lastWIPNo = this.ErpConfig[0].LastPrdJobNo;
      }
      else{
        this.lastProjectWIPNo = this.ErpConfig[0].LastProjectWIPNo;
      }
      
    }

    let tempErpProdDetails = this.apiService.getCookie("Cfg_AgnCfg")
    if (tempErpProdDetails) {
      this.ErpProd = JSON.parse(tempErpProdDetails);
      if(this.prTypeID == 1){
        this.lastWIPNo = this.ErpProd[0].LastPrdJobNo;
      }
      else{
        this.lastProjectWIPNo = this.ErpProd[0].LastProjectWIPNo;
      }
    }

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      let erpAgnJSON = JSON.parse(tmpERP_Agn);
      this.allowPrdFile = erpAgnJSON[0]?.AllowPrdFile ? true : false;
    }

    // this.filteredCstr = this.cstrCtrl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(x => x ? this._filterCstr(x) : this.customerList.slice())
    //   );
    this.appService.items.subscribe((value: any) => {
      
      if (this.prTypeID == 2) {
        this.items = value;
        
        if (this.items && this.items.length > 0) {
          this.projectType = this.items.length > 0 ? this.items[0].ItemName : '';
          this.data.Stages = this.items[0].StageFlow ? JSON.parse(this.items[0].StageFlow) : [];
          this.data.Stages.forEach((stage: any) => {
            stage.TDT = new Date()
          });
        }
        
      }
      else {
        if(this.firstTime){
          this.items = [];
          this.firstTime = false;
        }
        else {
          let origItems = this.items;
          this.items = value;
  
          this.items.forEach((e: any) => {
            let selItem = $.grep(origItems, function(o: any){ return o.ItemID == e["ItemID"]})
            e.PlanQty = selItem.length > 0 ? selItem[0].PlanQty : 0;
          });
  
            if((this.items.length == 1) && (this.items[0].LeadTime)) {
              let tDt = new Date();
              this.data.targetDate = new Date();
              
              this.data.targetDate.setDate(tDt.getDate() + this.items[0].LeadTime);
            
            }
          
        }
      }

      //this.lastWIPNo = 'AB001';
      //get Previous Number
      if(this.prTypeID == 1 && this.lastWIPNo){
        if(isNaN(this.lastWIPNo)) {
          this.isShowPrevNo = true;
        } 
        else {
          this.isShowPrevNo = false;
          this.data.WipNo = Number(this.lastWIPNo) + 1;
        }
      }

      if(this.prTypeID == 2 && this.lastProjectWIPNo){
        if(isNaN(this.lastProjectWIPNo)) {
          this.isShowPrevNo = true;
        } 
        else {
          this.isShowPrevNo = false;
          this.data.projectWipNo = Number(this.lastProjectWIPNo) + 1;
        }
      }
      
    });

   this.OrederItems  = this.Data ;
   if( this.OrederItems){
     let TempItem =  JSON.parse(this.OrederItems.OrdItemList)
     if(TempItem.length > 0){
      TempItem = TempItem.filter((x: any) => x.ItemID > 0)
     }
     this.items =  TempItem
     this.data.OrderID =   this.OrederItems.OrderID
     this.data.OrderNo = this.OrederItems.OrderNo
     this.data.cstrName = this.OrederItems.BuyerCompName;
     let a = new Date(new Date(this.OrederItems.DueDT).getFullYear(), new Date(this.OrederItems.DueDT).getMonth() + 0, 1);
     this.startDate = new FormControl(new Date(a))
     this.data.targetDate =  new Date(this.OrederItems.DueDT) 

     let tempData = this.customerList.filter((x: any) => x.Cmp ==  this.OrederItems.BuyerCompName)
     if (tempData.length > 0) {
       this.data.cstrName = tempData[0].Cmp;
       this.data.CstrRelativeID = tempData[0].RI;
     }
 

     this.items.forEach((x:any) => {
       x.ItemName = x.Item;
       x.ItemCode = x.Item;
       x.PlanQty =  x.OrderQty;
       x.SKU = x.SU
    });
   }
   else {
     this.copyDescFromOrder = false;
   }

   this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1000) {
        this.isMobileView = true;
    }

  }

  //auto complete Units
  private _filterCstr(value: string): CstrList[] {
    const filterValue = value.toLowerCase();
    return this.customerList.filter(state => state.Cmp.toLowerCase().indexOf(filterValue) === 0);
  }

  selectCustomer() {
    
    let tempData = this.customerList.filter((x: any) => x.Cmp == this.data.tempcstrName)
    if (tempData.length > 0) {
      this.data.cstrName = this.data.tempcstrName
      this.data.CstrRelativeID = tempData[0].RI
    }
  }

  removeCustomer() {
    this.data.cstrName = '';
    this.data.tempcstrName = '';
  }

  removeProjectType() {
    this.projectType = '';
    this.data.Stages = [];
  }

  passBack() {
    this.activeModal.dismiss();
  }

  close() {
    this.appService.updateItems([]);
    this.resetProjectEntry();
    this.mdlRef.close();
  }

  resetProjectEntry(): void {
    this.data.WipNo = '';
    this.data.projectWipNo = '';
    this.projectType = '';
    this.data.Stages = [];
    this.data.cstrName = '';
    this.data.tempcstrName = '';
  }

  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass: "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.it = this.items.map((a: any) => a.ItemID);
    // this.modalReference.componentInstance.st = this.frmStore.id;
    this.modalReference.componentInstance.stc = 0;
    this.modalReference.componentInstance.ft = 0;
    this.modalReference.componentInstance.isMade = 1;
    this.modalReference.componentInstance.prTypeID = this.prTypeID;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      this.apiService.successAlert('Please select a valid file.');
      return;
    }

    // Validate
    if (!['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif'].includes(file.type)) {
      this.apiService.successAlert('Only PDF and Image files are allowed.');
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      this.apiService.successAlert('File size should not exceed 2 MB.');
      return;
    }

    this.selectedFile = file;
    this.fileName = file.name;

    // Convert file to base64
    const reader = new FileReader();
    reader.onload = () => {
      this.fileBase64 = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeFile(): void {
    this.selectedFile = null;
    this.fileName = '';
    const fileInput = document.getElementById('addAttechment') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
    const fileInputMob = document.getElementById('addAttechmentMob') as HTMLInputElement;
    if (fileInputMob) fileInputMob.value = '';
  }

  async save() {
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")
    this.generationList = [];

    //Validation
    if (this.prTypeID == 1 && this.data.WipNo == "") {
      alert('Please enter WIP No.');
      return;
    }
    if (this.prTypeID == 2 && this.data.projectWipNo == "") {
      alert('Please enter Project Title.');
      return;
    }

    if (this.items.length == 0) {
      if (this.prTypeID == 1) {
        alert('Please select product.');
        return;
      }
      else {
        this.generationList.push({
          ItemID: 0,
          PlanQty: 0,
          DoneQty: 0,
          XnIDs: ''
        });
      }
    }
    else {
      for (let i = 0; i < this.items.length; i++) {
        if( this.prTypeID == 1 && this.items[i].PlanQty == 0){
         alert('Please enter a qty.');
         return;
        }

        let description = '';

        if (this.isCopyDescVisible && this.copyDescFromOrder) {
          description = this.items[i].SellerNotes || '';
        }

        let obj = {
          ItemID: this.items[i].ItemID,
          PlanQty: this.prTypeID == 2 ? 0 : this.items[i].PlanQty + "",
          DoneQty: 0,
          XnIDs: '',
          Description: description,
        };
         this.generationList.push(obj);
       }
    }

    let userIDs = '';
    if (this.prTypeID == 2) { 
      let adminUser = this.data.users.find((user: any) => user.UserID == this.agencyData[0].AdminUserID);
      if (!adminUser) {
        adminUser = this.userList.find((user: any) => user.UserID == this.agencyData[0].AdminUserID);
        this.data.users.push(adminUser);
      }
      let currUser = this.data.users.find((user: any) => user.UserID == this.jarvisData[0].UserID);
      if (!currUser) {
        currUser = this.userList.find((user: any) => user.UserID == this.jarvisData[0].UserID);
        this.data.users.push(currUser);
      }
      userIDs = this.data.users.map((user: any) => user.UserID).join(',');
    }
    
    let stages = '[]';
    if (this.prTypeID == 1) {
      stages = this.ErpConfig[0].PrdJobStages;
    }
    else {
      this.data.Stages.forEach((stage: any) => {
        stage.TDT = new Date(stage.TDT).customFormat('#DD#-#MMM#-#YY#');
        stage.UIDs = userIDs;
      })
      stages = JSON.stringify(this.data.Stages);
    }

    // Upload file if selected
    let attachmentPath = '';
    if (this.selectedFile) {
      const timestamp = new Date().getTime();
      const newFileName = `${timestamp}~^${this.selectedFile.name}`;
      const strAgn = this.agencyData[0].ERPAgencyID.toString().padStart(10, '0');

      const mp = [{
        data: this.fileBase64,
        fileName: newFileName,
        folderName: 'Files/' + strAgn,
        subFolder: 'Jobs',
        agencyID: this.agencyData[0].ERPAgencyID
      }];

      try {
        await new Promise((resolve, reject) => {
          this.apiService.uploadFile(mp, (result: string) => {
            attachmentPath = result;
            resolve(result);
          }, (error: any) => {
            reject(error);
          });
        });
      } catch (error) {
        console.error('File upload error:', error);
        this.apiService.errorAlert('Failed to upload file. Please try again.');
        return;
      }
    }

    // if(this.items.length == 1 && this.items[0].StageFlow != '' ){
    //   this.data.Stages = this.items[0].StageFlow
    // }
    // else{
    //  this.data.Stages = this.ErpConfig[0].PrdJobStages
    // }
      
    
    // else if (this.data.cstrName == "") {
    //   alert('Please select customer.');
    //   return;
    // }
  
    var tempData = [{
      'JobID': this.data.jobID,
      'JobNo': this.prTypeID == 1 ? this.data.WipNo : this.data.projectWipNo,
      'CurrStageID': this.data.CurrStageID,
      'CurrStage': this.data.CurrStageName,
      'TargetDT': new Date(this.data.targetDate).customFormat('#DD#-#MMM#-#YY#'),
      'Stages': stages,
      'Generation': JSON.stringify(this.generationList),
      'Consumption': '[]',
      'CstrRelativeID': this.data.CstrRelativeID ? this.data.CstrRelativeID : 0,
      'CstrRelName': this.data.cstrName ? this.data.cstrName : '',
      'OrderID': this.data.OrderID,
      'instruction': this.data.instruction,
      'JobTypeID': this.prTypeID == 2 ? 2 : 1,
      'UIDs': userIDs,
      'attachment': attachmentPath,
      "launchDT": new Date(this.data.launchDT).customFormat('#DD#-#MMM#-#YY#'),
      "isOrdItemDesc": this.copyDescFromOrder && this.isCopyDescVisible ? true : false
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'set',
      moduleID: 7,
      data: JSON.stringify(tempData)
    }];
    this.apiService.sendChange(myParams, this.successVchrEntry.bind(this), this.failureResp.bind(this));
    
  }


  //successVchrEntry - success voucher entry handler
  successVchrEntry(res: any) {
    // this.closeModel();
    if (res.error) {
      console.log(res.message);
    }
    else {
      let doneObj = {
        action: 'Done',
        obj: res,
      }
      let agencyConfig = this.apiService.getCookie('Cfg_AgnCfg');
      if (agencyConfig) {
          agencyConfig = JSON.parse(agencyConfig);
          let fnllAgencyConfigData: any = [];
          fnllAgencyConfigData = agencyConfig;
          if (fnllAgencyConfigData.length > 0) {
            if(this.prTypeID == 1)
            {
              fnllAgencyConfigData[0].LastPrdJobNo = this.data.WipNo;
            }
            else{
              fnllAgencyConfigData[0].LastProjectWIPNo = this.data.projectWipNo;
            }
              
          }
          this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(fnllAgencyConfigData));
      }
      else {
          let cookieData : any
          if(this.prTypeID == 1){
            cookieData = [{
              LastPrdJobNo : this.data.WIPNo 
            }];
          }
          else{
           cookieData = [{
            LastProjectWIPNo : this.data.projectWipNo 
            }];
          }
         
          this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(cookieData));
      }
      this.apiService.removeCookie('MyLastSyncDT');
      this.mdlRef.close(doneObj);
      // this.closeEntryModal();
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      alert(res.message);
    }
    // this.closeModel();
    let doneObj = {
      action: 'Close',
      obj: null
    }
    //this.mdlRef.close(doneObj);

  }

  checkPrecision(obj: any) {
    obj.PlanQty = this.commonService.PrecisionwiseValue(obj.PlanQty + '', obj.SKUPrecision);
  }

  //end

  
// new Product Entry on direct Production
  openEntryModal() {
    this.modalReference = this.modalService.open(ItemEntryComponent, { windowClass: 'WebModalItemsEntry', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
    
    })
  }

  openCompModal() { 
    
    let tmpCust = this.customerList.filter((a: any) => a.C == true);
    
    if (tmpCust.length == 0) {
        this.apiService.successAlert('Please configure the customer from Network > Connections.');
        return;
    }
    this.modalReference = this.modalService.open(FindCompComponent, {
        windowClass: "findCmp width100",
        backdrop: 'static',
        keyboard: false
    });
    this.modalReference.componentInstance.isCust = true;
    this.modalReference.componentInstance.custID = this.data.cstrID;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    
    this.modalReference.result.then((result: any) => {
       if(result){
        if (result.length > 0) {
          this.data.cstrName = String(result[0].Cmp).trim() == "-"  ? result[0].Name : result[0].Cmp;
          this.data.CstrRelativeID = result[0].RI
        }
       }
       
    });
  }

  addStage(): void {
    if (this.newStage == '') {
      this.apiService.successAlert('Please add stage name.');
      return;
    }

    const stage = {
      SID: Math.max(0, ...this.data.Stages.map((obj: any) => Number(obj.SID? obj.SID : "0"))) + 1,
      SNm: this.newStage,
      UIDs: this.jarvisData[0].UserID,
      Seq: Math.max(0, ...this.data.Stages.map((obj: any) => Number(obj.Seq? obj.Seq : "0"))) + 1,
      TID: 2,
      TDT: new Date()
    }
    this.data.Stages.push(stage);
    this.newStage = '';
  }

  removeStage(index: number): void {
    this.data.Stages.splice(index, 1);
  }

  clearAddStage(): void {
    this.newStage = '';
  }

  selectUser(): void {
    if (this.selectedUserID == 0) {
        this.apiService.successAlert('Please select a valid executive.');
        return;
    }

    const user = this.userList.find((user: any) => user.UserID == this.selectedUserID);
    if (user) {
        user.selected = true;
        this.data.users.push(user);
    }
    this.selectedUserID = 0; 
  }

  removeUser(index: number): void {
    const user = this.data.users[index];
    this.userList.forEach((u: any) => {
        if (user.UserID == u.UserID) {
            u.selected = false;
        }
    });
    this.data.users.splice(index, 1);
    this.selectedUserID = 0;
  }

  changeTargetDate(): void {
    let targetDT = this.data.targetDate
    let overDueStages = $.grep(this.data.Stages, function(o: any){ return o.TDT > targetDT })
    if (overDueStages.length > 0) {
      this.data.Stages.forEach((stage: any) => {
        if (stage.TDT > targetDT) {
          stage.TDT = targetDT;
        }
      });
    }
  }

  changeLaunchDT(): void {
    let launchDT = this.data.launchDT;
    let targetDT = this.data.targetDate;
    let today = this.todayDate;

    if (!launchDT) return;

    // Convert dates to timestamps for comparison
    let launch = new Date(launchDT).getTime();
    let todayTS = new Date(today).getTime();
    let targetTS = targetDT ? new Date(targetDT).getTime() : null;

    // Cannot be more than today's date
    if (launch > todayTS) {
      this.data.launchDT = today;
      return;
    }

    // Cannot be more than target date
    if (targetTS && launch > targetTS) {
      this.data.launchDT = targetDT;
      return;
    }
  }

}

export interface CstrList {
  Cmp: string;
  RI: number;
}


